import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { translations } from '../translations';
import '../styles/pages/SubscriptionResult.css';

function SubscriptionSuccess({ language }) {
  const [countdown, setCountdown] = useState(5);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const t = translations[language];
  
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/');
          window.location.reload();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <div className="subscription-result-container">
      <div className="result-card success">
        <div className="result-icon success-icon">✓</div>
        <h1>{t.subscriptionSuccessTitle || 'Payment Successful!'}</h1>
        <p className="result-message">
          {t.subscriptionSuccessMessage || 'Thank you for your subscription. Your account has been activated.'}
        </p>
        <p className="redirect-message">
          {t.redirectingIn || 'Redirecting to home in'} {countdown} {t.seconds || 'seconds'}...
        </p>
        <button 
          className="result-button"
          onClick={() => {
            navigate('/');
            window.location.reload();
          }}
        >
          {t.goToHome || 'Go to Home'}
        </button>
      </div>
    </div>
  );
}

export default SubscriptionSuccess;
